<template>
  <v-img v-if="url" height="40" width="40" :src="url"></v-img>
  <v-btn v-else depressed><v-icon small color="grey" class="pa-0">mdi-folder-image</v-icon></v-btn>
</template>

<script>
export default {
  name: 'DictionariesPicture',
  props: {
    url: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.v-btn {
  width: 40px !important;
  height: 40px !important;
  min-width: 40px !important;
  border: 1px solid #e0e0e0;
}
.v-image {
  border-radius: 3px;
  cursor: pointer !important;
}
</style>
